// extracted by mini-css-extract-plugin
export default {"wrapper":"U2-z","play":"V2-z"};